import StyledRating from "@/pages/All/StyledRating";
import {declOfNum} from "@/shared/lib/number/declOfNum";
import styles from "./ProductReviewStats.module.scss";
import {Svg} from "@/shared/ui/Svg";

type Props = {
    ratingAVG: number | null;
    totalCountOfReviews: number;
    ratingStats: Record<number, number>;
}

export const ProductReviewStats = ({ratingAVG, totalCountOfReviews, ratingStats}: Props) => {

    return (
        <div className={styles.stats}>
            <p className={styles.ratingAVG}>{ratingAVG}</p>
            <div className={styles.info}>
                <div className={styles.stars}>
                    <Svg id={`star`} className={styles.starIcon} />
                    <Svg id={`star`} className={styles.starIcon} />
                    <Svg id={`star`} className={styles.starIcon} />
                    <Svg id={`star`} className={styles.starIcon} />
                    <Svg id={`star`} className={styles.starIcon} />
                </div>
                <p className={styles.text}>оценка покупателей</p>
            </div>
            {/*<div className={`reviews__detailedDescription`}>*/}
            {/*    <div className={`info-wrap`}>*/}
            {/*        <div className={`info-wrap__item info-wrap__item_1`}>*/}
            {/*            <div className={`averageMarkContainer`}>*/}
            {/*                <p className={`averageMarkContainer__text`}>Оценка</p>*/}
            {/*                <p className={`averageMarkContainer__mark`}>{ratingAVG}</p>*/}
            {/*            </div>*/}
            {/*            <div className={`all-reviews`}>*/}
            {/*                <p className={`number-reviews`}>*/}
            {/*                    <span>{totalCountOfReviews} </span>*/}
            {/*                    {declOfNum(totalCountOfReviews, ['отзыв', 'отзыва', 'отзывов'])}*/}
            {/*                </p>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*        <div className={`info-wrap__item info-wrap__item_2`}>*/}
            {/*            {[5, 4, 3, 2, 1].map((rate) => (*/}
            {/*                <div key={rate} className={`el-wrapper`}>*/}
            {/*                    <StyledRating ratingAVG={rate} />*/}
            {/*                    <div className={`el-wrapper__desc`}>*/}
            {/*                        <span>{ratingStats[rate]} </span>*/}
            {/*                        <span>*/}
            {/*                        {declOfNum(ratingStats[rate], ['отзыв', 'отзыва', 'отзывов'])}*/}
            {/*                    </span>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            ))}*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>
    );
}
